import styled from 'styled-components';
import { space, typography, layout } from 'styled-system';
import { color } from '../../utils/styled-components/styledSystem';
import { baseDefaultProps } from './BaseDefaultProps';
import { HeadingProps } from './HeadingProps';

export const H1 = styled.h1<HeadingProps>`
    ${space}
    ${layout}
    ${typography}
    ${color}
`;

H1.displayName = 'H1';

H1.defaultProps = {
    ...baseDefaultProps,
    fontWeight: '600',
    margin: '0 0 0.5em 0',
    padding: '0',
    fontSize: {
        default: '26px',
        tablet: '48px',
    },
    lineHeight: {
        default: '34px',
        tablet: '60px',
    },
};
